import { fetchProductDeliveryWeeks } from '../actions/routines';
import { call, put } from 'redux-saga/effects';
import Products from '../services/api/Products';

export function* fetchProductDeliveryWeeksSaga(action) {
    try {
        yield put(fetchProductDeliveryWeeks.request());

        console.log('action.payload', action.payload);
        const response = yield call(
            Products.getProductDeliveryWeeks,
            action.payload
        );

        yield put(fetchProductDeliveryWeeks.success(response.data));
    } catch (error) {
        yield put(fetchProductDeliveryWeeks.failure(error.message));
    } finally {
        yield put(fetchProductDeliveryWeeks.fulfill());
    }
}
